import { render, staticRenderFns } from "./ToSSapphire.vue?vue&type=template&id=17b2652e"
import script from "./ToSSapphire.vue?vue&type=script&lang=js"
export * from "./ToSSapphire.vue?vue&type=script&lang=js"
import style0 from "./ToSSapphire.vue?vue&type=style&index=0&id=17b2652e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports